import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

export interface User {
  id: string;
  email: string;
  name: string;
  system_role: "LEARNER" | "TRAINER" | "ACADEMY_ADMIN" | "OWNER";
  career_stage: string;
  data_class?: string;
  force_password_change?: boolean;
}

interface AuthCtx {
  user: User | null | false;
  login: (email: string, password: string) => Promise<any>;
  logout: () => Promise<void>;
  refreshMe: () => Promise<any>;
}

const Ctx = createContext<AuthCtx>({} as AuthCtx);
export const useAuth = () => useContext(Ctx);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null | false>(null);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email: string, password: string) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("vytali_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("vytali_token");
    setUser(false);
  };

  const refreshMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch { setUser(false); return false; }
  };

  return <Ctx.Provider value={{ user, login, logout, refreshMe }}>{children}</Ctx.Provider>;
};
